/** Stroke-only outline paths — same glyphs as BlockScope / InstructionEditor preview. */
export const CHANNEL_MODALITY_ICON_PATHS = {
  text: 'M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5Z',
  voice: 'M12 1a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3Zm7 10a7 7 0 0 1-14 0M12 18v4M8 22h8',
};

/** Maps timeout/settings `chat` channel key to instruction-editor `text` modality. */
export const channelKeyToModality = channel => (channel === 'voice' ? 'voice' : 'text');

const modalityKey = modality => (modality === 'voice' ? 'voice' : 'text');

/** DOM helper for BlockScope chip widgets (stroke outline, not mdi). */
export const createChannelModalitySvgElement = (modality, size = 13) => {
  const name = modalityKey(modality);
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('width', String(size));
  svg.setAttribute('height', String(size));
  svg.setAttribute('aria-hidden', 'true');
  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute('d', CHANNEL_MODALITY_ICON_PATHS[name] || '');
  path.setAttribute('fill', 'none');
  path.setAttribute('stroke', 'currentColor');
  path.setAttribute('stroke-width', '1.6');
  path.setAttribute('stroke-linecap', 'round');
  path.setAttribute('stroke-linejoin', 'round');
  svg.appendChild(path);
  return svg;
};
